import { Controller } from "stimulus"

// Panneau repliable (filtres des tableaux, formulaires de statistiques).
// Syntaxe historique `data-target="accordion.content"` (Stimulus 2).
export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.hasContentTarget) {
      return
    }

    const open = this.contentTarget.classList.toggle("is-active")

    // Le conteneur porte aussi l'etat (ex. carte « Filtres » : Masquer / Afficher).
    this.element.classList.toggle("is-open", open)

    // Le declencheur (bouton ou lien) reflete l'etat pour les lecteurs d'ecran.
    const trigger = event && event.currentTarget
    if (trigger && trigger.setAttribute) {
      trigger.setAttribute("aria-expanded", open ? "true" : "false")
    }
  }
}
